/* Sun Energy Depot redesign: interactions */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    const drawer = $('#SedDrawer');
    if (!drawer || drawer.dataset.ready) return;
    drawer.dataset.ready = '1';
    const openers = $$('[data-sd-drawer-open]');
    const open = () => {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('overflow-hidden');
      const c = $('[data-sd-drawer-close].sd-icon-btn', drawer);
      if (c) c.focus();
    };
    const close = () => {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('overflow-hidden');
    };
    openers.forEach((b) => b.addEventListener('click', open));
    $$('[data-sd-drawer-close]', drawer).forEach((b) => b.addEventListener('click', close));
    drawer.addEventListener('keyup', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ---------- Mega menu: close after a link is clicked ---------- */
  function initMega() {
    $$('.sd-nav-item .sd-mega a').forEach((a) => {
      if (a.dataset.ready) return;
      a.dataset.ready = '1';
      a.addEventListener('click', () => {
        const li = a.closest('.sd-nav-item');
        li.classList.add('sd-closing');
        setTimeout(() => li.classList.remove('sd-closing'), 400);
        if (document.activeElement) document.activeElement.blur();
      });
    });
    $$('.sd-nav-item').forEach((li) => {
      li.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') { li.classList.add('sd-closing'); if (document.activeElement) document.activeElement.blur(); setTimeout(() => li.classList.remove('sd-closing'), 400); }
      });
    });
  }

  /* ---------- Hero slider ---------- */
  function initSliders(root = document) {
    $$('[data-sd-slider]', root).forEach((slider) => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = '1';
      const slides = $$('.sd-slide', slider);
      const dotsWrap = $('.sd-dots', slider);
      if (slides.length < 2) { const c = $('.sd-slider-ctrl', slider); if (c) c.hidden = true; return; }
      let i = 0, timer;
      const speed = (parseInt(slider.dataset.speed, 10) || 7) * 1000;
      dotsWrap.innerHTML = slides.map((_, n) => `<button type="button" class="sd-dot" aria-label="Show slide ${n + 1}" aria-current="${n === 0}"></button>`).join('');
      const dots = $$('.sd-dot', dotsWrap);
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => { s.classList.toggle('active', k === i); s.setAttribute('aria-hidden', String(k !== i)); $$('a,button', s).forEach((el) => (el.tabIndex = k === i ? 0 : -1)); });
        dots.forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
      }
      function play() { clearInterval(timer); if (slider.dataset.autoplay !== 'false' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => go(i + 1), speed); }
      dots.forEach((d, k) => d.addEventListener('click', () => { go(k); play(); }));
      const prev = $('[data-sd-prev]', slider), next = $('[data-sd-next]', slider);
      if (prev) prev.addEventListener('click', () => { go(i - 1); play(); });
      if (next) next.addEventListener('click', () => { go(i + 1); play(); });
      slider.addEventListener('mouseenter', () => clearInterval(timer));
      slider.addEventListener('mouseleave', play);
      slider.addEventListener('focusin', () => clearInterval(timer));
      go(0); play();
    });
  }

  /* ---------- Product gallery + lightbox ---------- */
  function initGallery(root = document) {
    $$('[data-sd-gallery]', root).forEach((gal) => {
      if (gal.dataset.ready) return;
      gal.dataset.ready = '1';
      const thumbs = $$('[data-sd-thumb]', gal);
      const stage = $('.sd-stage', gal);
      const stageImg = $('.sd-stage > img', gal);
      const count = $('.sd-stage-count', gal);
      if (!stage || !stageImg || !thumbs.length) return;
      let gi = Math.max(0, thumbs.findIndex((t) => t.classList.contains('active')));
      const total = thumbs.length;

      function show(n, scroll = true) {
        gi = (n + total) % total;
        const t = thumbs[gi];
        stageImg.src = t.dataset.src;
        if (t.dataset.srcset) stageImg.srcset = t.dataset.srcset; else stageImg.removeAttribute('srcset');
        stageImg.alt = t.dataset.alt || '';
        if (count) count.textContent = `${gi + 1} / ${total}`;
        thumbs.forEach((x, k) => { x.classList.toggle('active', k === gi); x.setAttribute('aria-current', String(k === gi)); });
        if (scroll) { const wrap = t.parentElement; if (wrap) { const r = t.getBoundingClientRect(), w = wrap.getBoundingClientRect(); if (r.top < w.top || r.bottom > w.bottom || r.left < w.left || r.right > w.right) t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } }
      }
      gal.sdShowMedia = (mediaId) => { const k = thumbs.findIndex((t) => t.dataset.mediaId === String(mediaId)); if (k > -1) show(k); };
      thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
      const prev = $('[data-sd-gprev]', gal), next = $('[data-sd-gnext]', gal);
      if (prev) prev.addEventListener('click', (e) => { e.stopPropagation(); show(gi - 1); });
      if (next) next.addEventListener('click', (e) => { e.stopPropagation(); show(gi + 1); });

      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (canHover) {
        stage.addEventListener('mousemove', (e) => {
          if (e.target.closest('button')) { stageImg.style.transform = ''; return; }
          const r = stage.getBoundingClientRect();
          stageImg.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
          stageImg.style.transform = 'scale(1.9)';
        });
        stage.addEventListener('mouseleave', () => { stageImg.style.transform = ''; });
      }

      // Lightbox
      const lb = $('[data-sd-lightbox]');
      let li = 0;
      function lbShow(n) {
        li = (n + total) % total;
        const img = $('img', lb);
        img.src = thumbs[li].dataset.lb;
        img.alt = thumbs[li].dataset.alt || '';
        $('.sd-lb-count', lb).textContent = `${li + 1} / ${total}`;
      }
      function openLB(n) { if (!lb) return; lbShow(n); lb.classList.add('open'); lb.setAttribute('aria-hidden', 'false'); document.body.classList.add('overflow-hidden'); $('.sd-lb-close', lb).focus(); }
      function closeLB() { lb.classList.remove('open'); lb.setAttribute('aria-hidden', 'true'); document.body.classList.remove('overflow-hidden'); show(li, false); stage.focus(); }
      stage.addEventListener('click', (e) => { if (!e.target.closest('button')) openLB(gi); });
      stage.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLB(gi); } if (e.key === 'ArrowLeft') show(gi - 1); if (e.key === 'ArrowRight') show(gi + 1); });
      if (lb && !lb.dataset.ready) {
        lb.dataset.ready = '1';
        $('.sd-lb-close', lb).addEventListener('click', closeLB);
        $('.sd-lb-prev', lb).addEventListener('click', () => lbShow(li - 1));
        $('.sd-lb-next', lb).addEventListener('click', () => lbShow(li + 1));
        lb.addEventListener('click', (e) => { if (e.target === lb) closeLB(); });
        document.addEventListener('keydown', (e) => {
          if (!lb.classList.contains('open')) return;
          if (e.key === 'Escape') closeLB();
          if (e.key === 'ArrowLeft') lbShow(li - 1);
          if (e.key === 'ArrowRight') lbShow(li + 1);
        });
      }
      show(gi, false);
    });
  }

  /* ---------- Product page: sub-nav, sticky add to cart, variant sync ---------- */
  function initPdp() {
    const subnav = $('[data-sd-subnav]');
    const links = subnav ? $$('a[href^="#"]', subnav) : [];
    const ids = links.map((a) => a.getAttribute('href').slice(1)).filter((id) => document.getElementById(id));
    const sticky = $('[data-sd-sticky-atc]');
    const buyRow = $('[data-sd-buy-row]');

    if (!window.__sdScrollLinks) {
      window.__sdScrollLinks = true;
      document.addEventListener('click', (e) => {
        const a = e.target.closest('a[data-sd-scroll]');
        if (!a) return;
        const t = document.getElementById(a.getAttribute('href').slice(1));
        if (!t) return;
        e.preventDefault();
        const sn = $('[data-sd-subnav]');
        const off = sn ? sn.offsetHeight + 4 : 12;
        window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - off, behavior: 'smooth' });
        history.replaceState(null, '', a.getAttribute('href'));
      });
    }

    let ticking = false;
    function onScroll() {
      ticking = false;
      if (ids.length) {
        let cur = ids[0];
        ids.forEach((id) => { const el = document.getElementById(id); if (el && el.getBoundingClientRect().top < 140) cur = id; });
        links.forEach((a) => a.classList.toggle('active', a.getAttribute('href') === '#' + cur));
      }
      if (sticky && buyRow) {
        const show = buyRow.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('show', show);
        sticky.setAttribute('aria-hidden', String(!show));
        $$('button, a', sticky).forEach((b) => (b.tabIndex = show ? 0 : -1));
        document.body.classList.toggle('sd-atc-up', show);
      }
    }
    if (ids.length || sticky) {
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
      onScroll();
    }

    if (sticky && !sticky.dataset.ready) {
      sticky.dataset.ready = '1';
      sticky.addEventListener('click', (e) => {
        const b = e.target.closest('[data-sd-sticky-add]');
        if (!b) return;
        const main = document.getElementById(b.dataset.target);
        if (main && !main.disabled) main.click();
        else if (buyRow) buyRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // Keep the custom gallery + sticky bar in step with Dawn's variant picker
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && !window.__sdVariantSub) {
      window.__sdVariantSub = true;
      subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
        const v = evt && evt.data && evt.data.variant;
        const html = evt && evt.data && evt.data.html;
        if (v && v.featured_media) {
          const gal = $('[data-sd-gallery]');
          if (gal && gal.sdShowMedia) gal.sdShowMedia(v.featured_media.id);
        }
        const st = $('[data-sd-sticky-atc]');
        if (html && st) {
          const src = html.querySelector('[data-sd-sticky-price]');
          const dst = $('[data-sd-sticky-price]', st);
          if (src && dst) dst.innerHTML = src.innerHTML;
          const sb = $('[data-sd-sticky-add]', st);
          if (sb && v) { sb.disabled = !v.available; sb.textContent = v.available ? 'Add to cart' : 'Sold out'; }
        }
        if (html) {
          ['[data-sd-ship]'].forEach((sel) => {
            const s = html.querySelector(sel), d = document.querySelector(sel);
            if (s && d) d.innerHTML = s.innerHTML;
          });
        }
      });
    }
  }

  function init(root) {
    initDrawer();
    initMega();
    initSliders(root);
    initGallery(root);
  }

  document.addEventListener('DOMContentLoaded', () => { init(document); initPdp(); });
  document.addEventListener('shopify:section:load', (e) => { init(e.target); initPdp(); });
})();